<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <div class="row">

                <div class="col-lg-8">

                    <h2 class="mb-4">
                        Jacob
                    </h2>

                    <h5>Series Aims</h5>
                    <ul>
                        <li>
                            To teach that God is faithful to all his promises.
                        </li>
                        <li>
                            To understand that God's purposes are greater than our sin or the sin of those who oppose us.
                        </li>
                        <li>
                            To understand that the Christian life is a process of learning to trust entirely upon God's grace in Jesus rather than our efforts or abilities.
                        </li>
                    </ul>

                    <h5 class="mt-4">Series Overview</h5>
                    <p>
                        Lesson 1 reveals Jacob for who he really is, a deceiver and schemer who not only takes advantage of his brother, but who also deceives his father into giving him the birthright. Lesson 2 shows the result of this deceit - a fractured family and Jacob fleeing the murderous threats of his brother. God graciously meets with him in a vision and makes the same promises he made to Abraham. He also promises to protect Jacob and bring him back to the land he has promised to give him and his children. In lesson 3 Jacob arrives safely at his uncle Laban's house. Laban takes advantage of Jacob and after a number of episodes of deceit and trickery, God's promises start being fulfilled despite a great deal of scheming and plotting by all concerned. Finally, in lesson 4, God tells Jacob to go home. He returns a wealthy man with two wives and eleven children - God has kept his promises. But Jacob is terrified about meeting his brother and tries a number of different tricks to appease him. He needs to undergo one last struggle with God before he finally submits to God's grace and purposes in his life
                    </p>

                    <h5 class="mt-4">Series Outline</h5>
                    <p>
                        Lesson 1 - Deceiving (Genesis 25:19-34; 26:34-27:41)
                    </p>
                    <p>
                        Lesson 2 - Dreaming (Genesis 27:41 - 28:22)
                    </p>
                    <p>
                        Lesson 3 - Deceived (Genesis 29:1 - 30:43)
                    </p>
                    <p>
                        Lesson 4 - Trusting God (Genesis 31:1-3; 32:1 - 33:20)
                    </p>

                </div>

                <div class="offset-lg-1 col">

                    <promo-sidebar />

                </div>

            </div>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import PromoSidebar from "../partials/PromoSidebar.vue";

export default {
    name: "Jacob",

    components: {
        PromoSidebar,
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - Jacob`,
            meta: [
                {
                    name: 'description',
                    content: "To understand that God's purposes are greater than our sin or the sin of those who oppose us.",
                },
            ],
        };
    },
};
</script>
